export const SERVICE_WORKER_CONFIG_FILE_NAME =
  "service-worker-cache-config.json";
